<template>
  <UiModal
    ref="videoModal"
    v-bind="$attrs"
    rounded="none"
    background="transparent"
    height="100%"
    close-button="outside"
    @update:model-value="onChangeValue"
  >
    <UiVideo :id="id" container-size />
  </UiModal>
</template>

<script setup lang="ts">
interface Props {
  id?: string;
}
interface Emits {
  (e: 'close'): void;
}

withDefaults(defineProps<Props>(), {
  id: '',
});

const emit = defineEmits<Emits>();

const onChangeValue = (value: any) => {
  if (!value) emit('close');
};
</script>

<script lang="ts">
// $attrs are passed to UiModal explicitly, don't duplicate them on the root
export default {
  inheritAttrs: false,
};
</script>
